import * as React from 'react';

export class PencilIcon extends React.PureComponent<{}, {}> {
  public render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 -2 14 14">
        <g fill="#2B87DB" fillRule="nonzero">
          <path
            //tslint:disable-next-line:max-line-length
            d="M7.075 3.625l-5.85 5.85A.68.68 0 0 0 1 10v2.25c0 .45.3.75.75.75H4a.68.68 0 0 0 .525-.225l5.85-5.85-3.3-3.3zM12.775 3.475l-2.25-2.25c-.3-.3-.75-.3-1.05 0l-1.35 1.35 3.3 3.3 1.35-1.35c.3-.3.3-.75 0-1.05z"
          />
        </g>
      </svg>
    );
  }
}
